(() => {
  if (window.klaimLogoMotionLoaded || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
  window.klaimLogoMotionLoaded = true;

  const selector = '.header--logo, .fb__wordmark, .klaim-mobile-menu-lab__wordmark, .klaim-search-overlay__wordmark';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const logos = new Map();

  const hidden = element => Boolean(element.closest('[hidden], [aria-hidden="true"]')) ||
    getComputedStyle(element).visibility === 'hidden' || !element.getClientRects().length;

  function stop(state) {
    state.animation?.cancel();
    state.animation = null;
  }

  function play(element, state) {
    if (window.KlaimHeaderPanels?.active && element.closest('#SiteHeaderInner')) {
      state.armed = false;
      stop(state);
      return;
    }
    if (!state.inFrame || !state.armed || document.hidden || reducedMotion.matches ||
      document.documentElement.classList.contains('klaim-site-intro-active') || hidden(element)) return;
    if (!state.image.complete || !state.image.naturalWidth) return;

    state.armed = false;
    stop(state);
    // Only the artwork moves; the observed box and clickable area stay fixed.
    state.animation = state.image.animate([
      { transform: 'scale(0.55)' },
      { transform: 'translateY(0) scale(1)' }
    ], { duration: 760, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
    const animation = state.animation;
    animation.onfinish = () => {
      if (state.animation === animation) state.animation = null;
    };
  }

  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      const state = logos.get(entry.target);
      if (!state) continue;
      // Re-arm only after a full exit, not when scrolling around the entry threshold.
      if (!entry.isIntersecting || entry.intersectionRatio === 0) {
        state.inFrame = false;
        state.armed = true;
        stop(state);
      } else if (entry.intersectionRatio >= 0.35) {
        state.inFrame = true;
        play(entry.target, state);
      } else {
        state.inFrame = false;
      }
    }
  }, { threshold: [0, 0.35] });

  function register(root) {
    for (const element of root.querySelectorAll(selector)) {
      if (logos.has(element)) continue;
      const image = element.querySelector('img');
      if (!image) continue;
      const state = { image, inFrame: false, armed: true, animation: null };
      state.onLoad = () => play(element, state);
      image.addEventListener('load', state.onLoad);
      // Overlay logos can be geometrically in view while their parent is hidden.
      const overlay = element.closest('[aria-hidden]');
      if (overlay) {
        state.overlayObserver = new MutationObserver(() => {
          if (hidden(element)) {
            state.armed = true;
            stop(state);
          } else {
            play(element, state);
          }
        });
        state.overlayObserver.observe(overlay, { attributes: true, attributeFilter: ['aria-hidden', 'hidden'] });
      }
      logos.set(element, state);
      observer.observe(element);
    }
  }

  function resume() {
    for (const [element, state] of logos) play(element, state);
  }

  register(document);
  window.addEventListener('klaim:header-panel-open', () => {
    for (const [element, state] of logos) {
      if (!element.closest('#SiteHeaderInner')) continue;
      state.armed = false;
      stop(state);
    }
  });
  window.addEventListener('klaim:site-intro-complete', resume);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      for (const state of logos.values()) stop(state);
    } else resume();
  });
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) {
      for (const state of logos.values()) stop(state);
    }
  });
  document.addEventListener('shopify:section:load', event => register(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [element, state] of logos) {
      if (!event.target.contains(element)) continue;
      stop(state);
      observer.unobserve(element);
      state.overlayObserver?.disconnect();
      state.image.removeEventListener('load', state.onLoad);
      logos.delete(element);
    }
  });
})();
